import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=936b4f64&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=936b4f64&prod&scoped=true&lang=css"
import style1 from "./AppMain.vue?vue&type=style&index=1&id=936b4f64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936b4f64",
  null
  
)

export default component.exports